<template>
  <div class="l-checkout__row">
    <div class="l-customer__left">
      <ValidationObserver ref="customerForm">
        <div
          class="l-customer__field l-customer__field--full"
          v-if="addresses.length > 0"
        >
          <ValidationProvider name="email" rules="required|email">
            <div
              class="o-input"
              :class="{ 'o-input--error': errors && errors.length }"
              slot-scope="{ errors }"
            >
              <input
                type="email"
                id="email"
                name="email"
                class="w-full validate input input--readonly"
                required="required"
                :class="{ valid: email }"
                v-model="email"
                :readonly="isReadOnly"
              />
              <label for="email"> E-mail </label>
            </div>
          </ValidationProvider>
        </div>
        <v-select
          :options="shippingAddresses"
          :placeholder="translations.choose"
          v-if="addresses.length > 0"
          v-model="shippingAddressId"
          :reduce="(shippingAddresses) => shippingAddresses.code"
        ></v-select>
        <input
          type="hidden"
          id="shippingAddress-id"
          v-model="shippingAddressId"
          name="shippingAddressId"
          class="w-full input"
          v-if="!showShippingInputs"
        />

        <div
          class="l-customer__fields shippingAddress"
          v-if="showShippingInputs"
        >
          <div class="l-customer__field l-customer__field--full">
            <ValidationProvider name="shippingBussinesname" rules="required">
              <div
                class="o-input"
                :class="{ 'o-input--error': errors && errors.length }"
                slot-scope="{ errors }"
              >
                <input
                  type="text"
                  id="shippingAddress[businessName]"
                  name="shippingAddress[businessName]"
                  required="required"
                  class="w-full validate input"
                  :readonly="readOnly"
                  :class="{ valid: shippingAddress.businessName }"
                  v-model="shippingAddress.businessName"
                />
                <label for="shippingAddress[businessName]">
                  {{ translations.customer }}
                </label>
              </div>
            </ValidationProvider>
          </div>
          <div class="l-customer__field l-customer__field--full">
            <ValidationProvider name="shippingTaxId" rules="required">
              <div
                class="o-input"
                :class="{ 'o-input--error': errors && errors.length }"
                slot-scope="{ errors }"
              >
                <input
                  type="text"
                  id="shippingAddress[businessTaxId]"
                  name="shippingAddress[businessTaxId]"
                  class="w-full validate input"
                  required="required"
                  :readonly="readOnly"
                  :class="{ valid: shippingAddress.businessTaxId }"
                  v-model="shippingAddress.businessTaxId"
                />
                <label for="shippingAddress[businessTaxId]">
                  {{ translations.vat }}
                </label>
              </div>
            </ValidationProvider>
          </div>
          <div class="l-customer__field l-customer__field--half">
            <ValidationProvider name="shippingFname" rules="required">
              <div
                class="o-input"
                :class="{ 'o-input--error': errors && errors.length }"
                slot-scope="{ errors }"
              >
                <input
                  type="text"
                  id="shippingAddress[firstName]"
                  name="shippingAddress[firstName]"
                  required="required"
                  class="w-full validate input"
                  :class="{ valid: shippingAddress.firstName }"
                  v-model="shippingAddress.firstName"
                />
                <label for="shippingAddress[firstName]">
                  {{ translations.firstName }}
                </label>
              </div>
            </ValidationProvider>
          </div>
          <div class="l-customer__field l-customer__field--half">
            <ValidationProvider name="shippingLName" rules="required">
              <div
                class="o-input"
                :class="{ 'o-input--error': errors && errors.length }"
                slot-scope="{ errors }"
              >
                <input
                  type="text"
                  id="shippingAddress[lastName]"
                  name="shippingAddress[lastName]"
                  required="required"
                  class="w-full validate input"
                  :class="{ valid: shippingAddress.lastName }"
                  v-model="shippingAddress.lastName"
                />
                <label for="shippingAddress[lastName]">
                  {{ translations.lastName }}
                </label>
              </div>
            </ValidationProvider>
          </div>
          <div class="l-customer__field l-customer__field--full">
            <ValidationProvider name="shippingPhone" rules="required">
              <div
                class="o-input"
                :class="{ 'o-input--error': errors && errors.length }"
                slot-scope="{ errors }"
              >
                <input
                  type="text"
                  id="shippingAddress[phone]"
                  name="shippingAddress[phone]"
                  required="required"
                  class="w-full validate input"
                  :class="{ valid: shippingAddress.phone }"
                  v-model="shippingAddress.phone"
                />
                <label for="shippingAddress[phone]">
                  {{ translations.phone }}
                </label>
              </div>
            </ValidationProvider>
          </div>
          <div
            class="l-customer__field l-customer__field--full"
            v-if="addresses.length == 0"
          >
            <ValidationProvider name="email" rules="required|email">
              <div
                class="o-input"
                :class="{ 'o-input--error': errors && errors.length }"
                slot-scope="{ errors }"
              >
                <input
                  type="email"
                  id="email"
                  name="email"
                  class="w-full validate input"
                  required="required"
                  :class="{ valid: email }"
                  v-model="email"
                />
                <label for="email"> E-mail </label>
              </div>
            </ValidationProvider>
          </div>
          <div class="l-customer__field l-customer__field--full">
            <ValidationProvider name="shippingAddress" rules="required">
              <div
                class="o-input"
                :class="{ 'o-input--error': errors && errors.length }"
                slot-scope="{ errors }"
              >
                <input
                  type="text"
                  id="shippingAddress[address1]"
                  name="shippingAddress[address1]"
                  required="required"
                  class="w-full validate input"
                  :class="{ valid: shippingAddress.address1 }"
                  v-model="shippingAddress.address1"
                />
                <label for="shippingAddress[address1]">
                  {{ translations.address }}
                </label>
              </div>
            </ValidationProvider>
          </div>
          <div class="l-customer__field l-customer__field--half">
            <ValidationProvider name="shippingZip" rules="required">
              <div
                class="o-input"
                :class="{ 'o-input--error': errors && errors.length }"
                slot-scope="{ errors }"
              >
                <input
                  type="text"
                  id="shippingAddress[zipCode]"
                  name="shippingAddress[zipCode]"
                  class="w-full validate input"
                  required="required"
                  :class="{ valid: shippingAddress.zipCode }"
                  v-model="shippingAddress.zipCode"
                />
                <label for="shippingAddress[zipCode]">
                  {{ translations.zipCode }}
                </label>
              </div>
            </ValidationProvider>
          </div>
          <div class="l-customer__field l-customer__field--half">
            <ValidationProvider name="shippingCity" rules="required">
              <div
                class="o-input"
                :class="{ 'o-input--error': errors && errors.length }"
                slot-scope="{ errors }"
              >
                <input
                  type="text"
                  id="shippingAddress[city]"
                  name="shippingAddress[city]"
                  class="w-full validate input"
                  required="required"
                  :class="{ valid: shippingAddress.city }"
                  v-model="shippingAddress.city"
                />
                <label for="shippingAddress[city]">
                  {{ translations.city }}
                </label>
              </div>
            </ValidationProvider>
          </div>
          <div class="l-customer__field l-customer__field--full">
            <ValidationProvider name="shippingCountry" rules="required">
              <v-select
                slot-scope="{ errors }"
                :options="enabledCountries"
                :placeholder="translations.country"
                :reduce="(enabledCountries) => enabledCountries.code"
                :class="{ 'select-error': errors && errors.length }"
                v-model="shippingAddress.countryId"
              ></v-select>
            </ValidationProvider>
          </div>
          <input
            type="hidden"
            id="shippingAddress-id"
            v-model="shippingAddress.countryId"
            name="shippingAddress[countryId]"
          />
        </div>

        <input
          class="o-checkbox__input"
          id="cbx"
          type="checkbox"
          style="display: none"
          v-model="alternateBilling"
        />
        <label class="o-checkbox" for="cbx"
          ><span>
            <svg width="12px" height="9px" viewbox="0 0 12 9">
              <polyline points="1 5 4 8 11 1"></polyline></svg></span
          ><span>{{ translations.isBilling }}</span></label
        >

        <input
          type="hidden"
          name="billingAddressSameAsShipping"
          :value="!alternateBilling"
        />

        <!--Billing-->
        <v-select
          :options="billingAddresses"
          :placeholder="translations.choose"
          v-if="addresses.length > 0 && alternateBilling"
          v-model="billingAddressId"
          :reduce="(billingAddresses) => billingAddresses.code"
        ></v-select>
        <input
          type="hidden"
          id="shippingAddress-id"
          v-model="shippingAddressId"
          name="shippingAddress[id]"
          class="w-full input"
          v-if="alternateBilling && !showBillingInputs"
        />

        <div
          class="l-customer__fields billingAddress"
          v-if="alternateBilling && showBillingInputs"
        >
          <div class="l-customer__field l-customer__field--full">
            <ValidationProvider name="billingBusiness" rules="required">
              <div
                class="o-input"
                :class="{ 'o-input--error': errors && errors.length }"
                slot-scope="{ errors }"
              >
                <input
                  type="text"
                  id="billingAddress[businessName]"
                  name="billingAddress[businessName]"
                  class="w-full validate input"
                  required="required"
                  :readonly="readOnly"
                  :class="{ valid: billingAddress.businessName }"
                  v-model="billingAddress.businessName"
                />
                <label for="billingAddress[businessName]">
                  {{ translations.customer }}
                </label>
              </div>
            </ValidationProvider>
          </div>
          <div class="l-customer__field l-customer__field--full">
            <ValidationProvider name="billingTax" rules="required">
              <div
                class="o-input"
                :class="{ 'o-input--error': errors && errors.length }"
                slot-scope="{ errors }"
              >
                <input
                  type="text"
                  id="billingAddress[businessTaxId]"
                  name="billingAddress[businessTaxId]"
                  class="w-full validate input"
                  required="required"
                  :readonly="readOnly"
                  :class="{ valid: billingAddress.businessTaxId }"
                  v-model="billingAddress.businessTaxId"
                />
                <label for="billingAddress[businessTaxId]">
                  {{ translations.vat }}
                </label>
              </div>
            </ValidationProvider>
          </div>
          <div class="l-customer__field l-customer__field--half">
            <ValidationProvider name="billingFirstname" rules="required">
              <div
                class="o-input"
                :class="{ 'o-input--error': errors && errors.length }"
                slot-scope="{ errors }"
              >
                <input
                  type="text"
                  id="billingAddress[firstName]"
                  name="billingAddress[firstName]"
                  class="w-full validate input"
                  required="required"
                  :class="{ valid: billingAddress.firstName }"
                  v-model="billingAddress.firstName"
                />
                <label for="billingAddress[firstName]">
                  {{ translations.firstName }}
                </label>
              </div>
            </ValidationProvider>
          </div>
          <div class="l-customer__field l-customer__field--half">
            <ValidationProvider name="billingLastname" rules="required">
              <div
                class="o-input"
                :class="{ 'o-input--error': errors && errors.length }"
                slot-scope="{ errors }"
              >
                <input
                  type="text"
                  id="billingAddress[lastName]"
                  name="billingAddress[lastName]"
                  class="w-full validate input"
                  required="required"
                  :class="{ valid: billingAddress.lastName }"
                  v-model="billingAddress.lastName"
                />
                <label for="billingAddress[lastName]">
                  {{ translations.lastName }}
                </label>
              </div>
            </ValidationProvider>
          </div>
          <div class="l-customer__field l-customer__field--full">
            <ValidationProvider name="billingPhone" rules="required">
              <div
                class="o-input"
                :class="{ 'o-input--error': errors && errors.length }"
                slot-scope="{ errors }"
              >
                <input
                  type="text"
                  id="billingAddress[phone]"
                  name="billingAddress[phone]"
                  class="w-full validate input"
                  required="required"
                  :class="{ valid: billingAddress.phone }"
                  v-model="billingAddress.phone"
                />
                <label for="billingAddress[phone]">
                  {{ translations.phone }}
                </label>
              </div>
            </ValidationProvider>
          </div>
          <div class="l-customer__field l-customer__field--full">
            <ValidationProvider name="billingAddress" rules="required">
              <div
                class="o-input"
                :class="{ 'o-input--error': errors && errors.length }"
                slot-scope="{ errors }"
              >
                <input
                  type="text"
                  id="billingAddress[address1]"
                  name="billingAddress[address1]"
                  class="w-full validate input"
                  required="required"
                  :class="{ valid: billingAddress.address1 }"
                  v-model="billingAddress.address1"
                />
                <label for="billingAddress[address1]">
                  {{ translations.address }}
                </label>
              </div>
            </ValidationProvider>
          </div>
          <div class="l-customer__field l-customer__field--half">
            <ValidationProvider name="billingZip" rules="required">
              <div
                class="o-input"
                :class="{ 'o-input--error': errors && errors.length }"
                slot-scope="{ errors }"
              >
                <input
                  type="text"
                  id="billingAddress[zipCode]"
                  name="billingAddress[zipCode]"
                  class="w-full validate input"
                  required="required"
                  :class="{ valid: billingAddress.zipCode }"
                  v-model="billingAddress.zipCode"
                />
                <label for="billingAddress[zipCode]">
                  {{ translations.zipCode }}
                </label>
              </div>
            </ValidationProvider>
          </div>
          <div class="l-customer__field l-customer__field--half">
            <ValidationProvider name="billingCity" rules="required">
              <div
                class="o-input"
                :class="{ 'o-input--error': errors && errors.length }"
                slot-scope="{ errors }"
              >
                <input
                  type="text"
                  id="billingAddress[city]"
                  name="billingAddress[city]"
                  class="w-full validate input"
                  required="required"
                  :class="{ valid: billingAddress.city }"
                  v-model="billingAddress.city"
                />
                <label for="billingAddress[city]">
                  {{ translations.city }}
                </label>
              </div>
            </ValidationProvider>
          </div>
          <div class="l-customer__field l-customer__field--full">
            <ValidationProvider name="billingCountry" rules="required">
              <v-select
                slot-scope="{ errors }"
                :options="enabledCountries"
                :placeholder="translations.country"
                :reduce="(enabledCountries) => enabledCountries.code"
                v-model="billingAddress.countryId"
                :class="{ 'select-error': errors && errors.length }"
              >
              </v-select>
            </ValidationProvider>
          </div>
          <input
            type="hidden"
            id="shippingAddress-id"
            v-model="shippingAddress.countryId"
            name="billingAddress[countryId]"
          />
        </div>
      </ValidationObserver>
    </div>

    <div class="l-customer__right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

import { ValidationProvider, ValidationObserver } from "vee-validate";

import { extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";

// Add the required rule
extend("required", {
  ...required,
  message: "This field is required",
});

// Add the email rule
extend("email", {
  ...email,
  message: "This field must be a valid email",
});

export default {
  name: "customer",
  components: {
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      shippingAddressId: parseInt(this.selectedshipping),
      billingAddressId: parseInt(this.selectedbilling),
      shippingAddress: {
        address1: "",
        businessName: "",
        businessTaxId: "",
        city: "",
        countryId: "",
        firstName: "",
        id: "",
        lastName: "",
        phone: "",
        zipCode: "",
      },
      billingAddress: {
        address1: "",
        businessName: "",
        businessTaxId: "",
        city: "",
        countryId: "",
        firstName: "",
        id: "",
        lastName: "",
        phone: "",
        zipCode: "",
      },
      alternateBilling: false,
      email: "",
    };
  },
  props: {
    translations: Object,
    forcedCompany: {
      type: String,
      default: null,
    },
    forcedVat: {
      type: String,
      default: null,
    },
    forcedEmail: {
      type: String,
      default: null,
    },
    addresses: Array,
    countries: Object,
    csrf: String,
    selectedshipping: {
      type: String,
      default: null,
    },
    selectedbilling: {
      type: String,
      default: null,
    },
  },
  computed: {
    isReadOnly() {
      if (this.forcedEmail) {
        return true;
      }

      return false;
    },
    enabledCountries() {
      let countries = [];
      for (const property in this.countries) {
        countries.push({
          label: this.countries[property].name,
          code: property,
        });
      }
      return countries;
    },
    shippingAddresses() {
      let shipping = [];
      for (const property in this.addresses) {
        shipping.push({
          label: `${this.addresses[property].businessName}, ${this.addresses[property].firstName} ${this.addresses[property].lastName}, ${this.addresses[property].address1}, ${this.addresses[property].zipCode} ${this.addresses[property].city}`,
          code: parseInt(this.addresses[property].id),
        });
      }

      shipping.push({
        label: this.translations.newShipping,
        code: 0,
      });

      return shipping;
    },
    billingAddresses() {
      let billings = [];
      for (const property in this.addresses) {
        billings.push({
          label: `${this.addresses[property].businessName}, ${this.addresses[property].firstName} ${this.addresses[property].lastName}, ${this.addresses[property].address1}, ${this.addresses[property].zipCode} ${this.addresses[property].city}`,
          code: parseInt(this.addresses[property].id),
        });
      }

      billings.push({
        label: this.translations.newBilling,
        code: 0,
      });

      return billings;
    },
    showShippingInputs() {
      if (this.shippingAddressId === 0) {
        return true;
      }

      if (this.addresses.length) {
        return false;
      }

      if (!isNaN(this.shippingAddressId)) {
        return false;
      }

      return true;
    },
    showBillingInputs() {
      if (this.billingAddressId === 0) {
        return true;
      }

      if (this.addresses.length) {
        return false;
      }

      if (!isNaN(this.billingAddressId)) {
        return false;
      }

      return true;
    },
    readOnly() {
      if (this.forcedCompany) {
        return true;
      }
    },
  },
  watch: {},
  methods: {
    validateForm() {
      return this.$refs.customerForm.validate().then((success) => {
        if (!success) {
          return false;
        }
        return true;
      });
    },
  },
  mounted() {
    if (this.forcedCompany) {
      this.shippingAddress.businessName = this.forcedCompany;
      this.billingAddress.businessName = this.forcedCompany;

      this.shippingAddress.businessTaxId = this.forcedVat;
      this.billingAddress.businessTaxId = this.forcedVat;
    }
    this.email = this.forcedEmail;
  },
};
</script>

<style lang="scss">
@import "../../scss/base/variables.scss";

.v-select {
  margin-bottom: 20px;

  input::placeholder {
    color: $brand-grey;
    font-size: 16px;
  }

  .vs__dropdown-option {
    &--selected,
    &--highlight {
      color: #fff;
      background: $brand-orange;
    }
  }
}
.select-error {
  .vs__dropdown-toggle {
    border-color: #a1160f;
  }
}
.vs__selected-options,
.vs__dropdown-toggle,
.v-select,
.vs__search,
.vs__dropdown-option {
  &:hover {
    cursor: pointer;
  }
}

.vs__dropdown-toggle {
  padding: 10px 3px;
}
</style>
